import { Box, Grid } from "@mui/material";
import { Outlet } from "react-router-dom";
import { Header, LeftNav, Notification } from "../components";
import useCacheBuster from "../hooks/useCacheBuster";
import Trial from "../components/Trial";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { setGeneralSettings } from "../store/generalSettingsSlice";
import { useEffect, useRef } from "react";

export const Layout = () => {
  useCacheBuster();
  const generalSettings = useSelector((state: RootState) => state.generalSettings);
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setGeneralSettings({ trialPopup: false }));
  };
  const mainContentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (mainContentRef.current) {
      mainContentRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [window.location.pathname]);

  return (
    <div className={`app`}>
      <Header />
      <Box className={`main`}>
        <Grid container sx={{ height: "calc(100vh - 81px)" }}>
          <Grid item width={290} sx={{ overflow: "auto", height: "100%" }}>
            <LeftNav />
          </Grid>
          <Grid
            ref={mainContentRef}
            item
            width={"calc(100% - 290px)"}
            p={6}
            sx={{ bgcolor: "#f5f5f5", height: "100%", overflow: "auto" }}
          >
            <Outlet />
          </Grid>
        </Grid>
        <Notification />
        <Trial open={Boolean(generalSettings.trialPopup)} close={handleClose} />
      </Box>
    </div>
  );
};
